import { EMAIL_LOCAL_PART_MAX_LENGTH } from '@promo/shared';

interface EmailInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  autoFocus?: boolean;
}

export const EmailInput = ({ value, onChange, error, autoFocus }: EmailInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow letters, numbers, dots, plus, and dash
    const newValue = e.target.value
      .replace(/[^a-zA-Z0-9.+-]/g, '')
      .slice(0, EMAIL_LOCAL_PART_MAX_LENGTH);
    onChange(newValue);
  };

  return (
    <div className="space-y-1">
      <div className="relative flex">
        <div className="w-1/2">
          <input
            type="text"
            placeholder="username"
            value={value}
            onChange={handleChange}
            maxLength={EMAIL_LOCAL_PART_MAX_LENGTH}
            autoFocus={autoFocus}
            aria-label="email"
            className={`
              input-base touch-target w-full
              text-mobile pr-0 pl-4
              text-right
              placeholder:text-gray-400
              ${error ? 'focus:ring-secondary' : 'focus:ring-primary'}
            `}
          />
        </div>
        <div className="w-1/2 flex items-center">
          <span className="text-gray-400 text-mobile">@tebra.com</span>
        </div>
      </div>
      {error && <p className="text-center error-text helper-mobile px-1">{error}</p>}
    </div>
  );
};
